import type { Role } from "../types/api";

const SESSION_KEY = "conecta.session";

export interface StoredSession {
  accessToken: string;
  refreshToken: string;
  role: Role;
}

export function getStoredSession(): StoredSession | null {
  try {
    const value = sessionStorage.getItem(SESSION_KEY);
    return value ? (JSON.parse(value) as StoredSession) : null;
  } catch {
    return null;
  }
}

export function saveSession(session: StoredSession): void {
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function clearSession(): void {
  sessionStorage.removeItem(SESSION_KEY);
  window.dispatchEvent(new Event("conecta:session-cleared"));
}
